import { Dispatch, SetStateAction, useEffect, useState } from 'react'

export default function loadPreferedObject(
    objects: any,
    {
        asset,
        objectType,
        dashboardId,
        editMode
    }: { asset: string; objectType: string; dashboardId: number; editMode: boolean }
): [string | null, Dispatch<SetStateAction<string | null>>] {
    const [current, setCurrent] = useState<string | null>(null)
    const controller = new AbortController()
    const signal = controller.signal
    const params = { dashboardId }
    const url = `/services/plugin-drilling-widgets/objects/${asset}/${objectType}/${dashboardId}?editMode=${editMode}`
    useEffect(() => {
        if (asset) {
            fetch(url, { signal })
                .then(r => r.text())
                .then((data: string) => {
                    console.log(`loaded current ${objectType} for ${asset} on dashboardId #${dashboardId} : ${data}`)
                    setCurrent(data)
                })
                .catch(e => console.error(e))

            return () => controller.abort()
        }
    }, [asset, objectType, dashboardId])

    return [current, setCurrent]
}
